export default {
  methods: {
    getStatusText (status) {
      switch (status) {
        case null: return 'Не в сети';
        case '-1': return 'Не зарегистрировано';
        case '0': return 'Отключено';
        case '1': return 'Регистрация';
        case '2': return 'Зарегистрировано';
        case '3': return 'Не удалось зарегистрироваться';
        case '4': return 'Не установлен';
        case '5': return 'Без интернет соединения';
        case '6': return 'Пусконаладка';
        case '7': return 'Старый домофон';
        case '8': return 'Ожидает монтажа';
        default: return 'Неизвестный статус';
      }
    },

    getStatusColor (status) {
      switch (status) {
        case null: return 'red';
        case '-1': return 'grey';
        case '0': return 'blue-grey';
        case '1': return 'green';
        case '2': return 'green';
        case '3': return 'red';
        case '4': return 'orange';
        case '5': return 'blue';
        case '6': return 'orange';
        case '7': return 'purple';
        case '8': return 'orange';
        default: return 'black';
      }
    },

    physicalStatus (item, isBarrier = false) {
      switch (item) {
        case 1: return 'Установлен';
        case 2: return 'Не установлен';
        case 3: return 'Без интернет соединения';
        case 4: return 'Пусконаладка';
        case 5: return isBarrier ? 'Старый шлагбаум' : 'Старый домофон';
        case 6: return 'Ожидает монтажа';
        default: return '';
      }
    },
    physicalStatusColor (item) {
      switch (item) {
        case 1: return 'green';
        case 2: return 'blue-grey';
        case 3: return 'purple';
        case 4: return 'orange';
        case 5: return 'orange';
        case 6: return 'orange';
        default: return 'black';
      }
    },

    getTranslatedType (type) {
      switch (type) {
        case 'barrier':
          return 'Шлагбаум';
        case 'gate':
          return 'Калитка';
        case 'M':
          return 'Домофон';
        case 'A':
          return 'Доп. Вход';
        case 'G':
          return 'Калитка-домофон';
        default:
          return 'Неизвестный тип';
      }
    },
  },
};
